export default {"src":"/_next/static/media/bridge-slateus.1ab9c419.svg","height":100,"width":100};